import { useLocation } from "react-router-dom";
import ProfilePage from "../shared/ProfilePage";
import AdminLayout from "../../layouts/AdminLayout";

export default function AdminProfile() {
  const location = useLocation();
  return (
    <ProfilePage
      Layout={AdminLayout}
      roleTitle="Admin"
      editable={true}
      defaultTab={location.state?.defaultTab || "attendance"}
    />
  );
}